import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import utils
import { setNamespace } from '@utils/namespacing';

// import styles
import './_button.scss';

const namespacify = setNamespace('et-core-button');

const Button = ({ className, disabled, handleClick, children, dense, stretch, margin, variant, rel }) => {
  const enabledClass = (disabled ? null : namespacify('_enabled'));
  const denseClass = (dense && namespacify('_dense'));
  const stretchClass = (stretch && namespacify('_stretch'));
  const marginClass = (margin && namespacify('_margin'));
  const variantClass = (variant && namespacify(`_variant_${ variant }`));

  return (
    <button
      className={classNames([
        namespacify(),
        className,
        variantClass,
        denseClass,
        stretchClass,
        marginClass,
        enabledClass
      ])}
      disabled={disabled}
      onClick={handleClick}
      rel={rel}
    >
      <span className={namespacify('_content')}>{ children }</span>
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  dense: PropTypes.bool,
  stretch: PropTypes.bool,
  variant: PropTypes.oneOf([ 'default', 'outlined' ])
};

Button.defaultProps = {
  className: '',
  disabled: false,
  stretch: false,
  handleClick: () => console.log('default Button handleClick event'),
  variant: 'default',
};

export default Button;
